module.exports = __webpack_public_path__ + "static/media/RS.6e843b9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/RS.svg
// module id = 2249
// module chunks = 7